<template>
    <div v-if="visible">
        <Modal :value="visible" :width="90" :mask-closable="false" :closable="false">
            <template #header>
                <div>
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div>
                            <h1 style="display: inline-block;">剧集上传</h1>
                            <a style="margin-left: 10px;text-decoration: underline;"
                                href="https://qcnepu9aol9y.feishu.cn/wiki/GkCiwOXlPiBUbDk5JILc8YiSn3e"
                                target="_blank">查看剧集上传教程</a>
                        </div>
                        <div>
                            <Icon type="ios-close" style="cursor: pointer;" :size="30"
                                @click="handleClickClose(false)" />
                        </div>
                    </div>
                    <div style="margin-top: 10px;display:flex;justify-content: space-between;">
                        <div>
                            <span :style="{
                                padding: '5px 10px',
                                backgroundColor: getColor(form.playRelease),
                                color: '#fff',
                                borderRadius: '90px',
                                display: 'inline-block'
                            }">
                                {{ form.playReleaseName }}</span>
                            <div style="display: inline-block;margin-left: 20px;color: #aaa">
                                短剧名称：{{ form.playName }}丨
                                中文名称：{{ form.chineseName }}丨
                                语言：{{ form.langName }}
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;">
                            <div style="color:red;margin-right: 10px;" v-if="res.taskStatus == 1 && uploadType == 0">
                                上传过程中请勿关闭或离开页面，否则会中断文件传输。</div>
                            <div v-else></div>
                            <Dropdown @on-click="handleChooseUpload">
                                <Button type="primary" :disabled="res.taskStatus == 1">批量上传</Button>
                                <template #list>
                                    <DropdownMenu>
                                        <DropdownItem name="baidu"
                                            :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                            百度网盘上传</DropdownItem>
                                        <DropdownItem name="local"
                                            :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                            本地上传</DropdownItem>
                                    </DropdownMenu>
                                </template>
                            </Dropdown>

                        </div>
                    </div>
                </div>
                <div v-if="res.taskStatus == 1" style="display: flex;align-items: center;margin-top: 20px;">
                    <span style="flex-shrink: 0;">上传进度：</span><Progress
                        :percent="(res.successTotal + res.videoUploadSeriesVOList.filter(i => i.status == 3 && i.isCurrentTask).length) / res.taskTotal * 100"
                        status="active" hide-info /> {{
                            res.successTotal + res.videoUploadSeriesVOList.filter(i => i.status == 3 && i.isCurrentTask).length}}/{{
                        res.taskTotal }}
                </div>
                <div v-else-if="res.taskStatus == 2">
                    <Icon type="md-checkmark-circle" color="#00d647" :size="14" />
                    上传已完成：本次共{{ res.taskTotal }}个视频文件
                </div>
                <div v-else-if="res.taskStatus == 3">
                    <Icon type="md-information-circle" :size="14" color="#fc474c" />
                    上传已完成：共上传{{ res.taskTotal }}个文件,成功{{ res.successTotal }}个,失败{{ res.taskTotal - res.successTotal
                    }}个(第 {{
                        res.videoUploadSeriesVOList.filter(i => i.status == 3 && i.isCurrentTask).map(i => i.seriesNum).join('、')}} 集)
                </div>
                <div v-else-if="res.taskStatus == 4">
                    <Icon type="md-close-circle" color="#fc474c" :size="14" />
                    上传失败：共{{ res.taskTotal }}个文件 (第 {{
                        res.videoUploadSeriesVOList.filter(i => i.status == 3 && i.isCurrentTask).map(i => i.seriesNum).join('、')
                    }} 集)
                </div>
            </template>
            <div style="background: #f1f7ff;padding: 10px">
                <div style="display:flex;flex-wrap: wrap;margin: 0 1%;min-height: calc(60vh)">
                    <div v-for="(item, index) in episodeLi.slice((this.page.current - 1) * this.page.size, this.page.current * this.page.size)"
                        :key="index" style="padding: 1.2%;box-sizing: border-box;flex: 0 11.11%;width: 11.11%">
                        <div style="background: #fff;height: 22vh;border-radius: 5px;overflow:hidden;position:relative
                            ">
                            <div v-if="item.name" style="position:absolute;z-index:10;inset:0">
                                <div style="width: 100%;height:100%;position:relative">

                                    <div v-if="item.status == 0"
                                        style="background-color: #e5e8ec;position:absolute;inset: 0;color: #666">
                                        <div
                                            style="position: absolute;left:50%;top:50%;transform:translate(-50%,-50%);text-align:center">
                                            <svg t="1762919532107" style="width:30px;height:30px" class="icon"
                                                viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                p-id="12254" width="200" height="200">
                                                <path
                                                    d="M20.48 20.48m81.92 0l819.2 0q81.92 0 81.92 81.92l0 819.2q0 81.92-81.92 81.92l-819.2 0q-81.92 0-81.92-81.92l0-819.2q0-81.92 81.92-81.92Z"
                                                    fill="#1296db" p-id="12255"
                                                    data-spm-anchor-id="a313x.search_index.0.i1.76cb3a81JoLBwp"
                                                    class="">
                                                </path>
                                                <path
                                                    d="M405.15584 318.7712c72.25344 42.04544 228.80256 129.1264 304.06656 171.17184 27.09504 15.01184 45.1584 27.0336 3.01056 48.04608-75.264 39.03488-225.792 129.1264-301.056 171.17184-30.1056 18.0224-45.17888 21.01248-42.16832-18.0224V330.79296c0-18.0224-6.02112-36.0448 36.1472-12.02176z"
                                                    fill="#ffffff" p-id="12256"
                                                    data-spm-anchor-id="a313x.search_index.0.i2.76cb3a81JoLBwp"
                                                    class="selected">
                                                </path>
                                            </svg>
                                            <div>{{ item.name }}</div>
                                            <div>{{ item.statusName }}</div>
                                        </div>
                                    </div>
                                    <div v-else-if="item.status === 1 || item.status === 2">
                                        <Dropdown placement="right"
                                            @on-click="handleChooseUpload($event, 'single', item)"
                                            style="position: absolute;inset:0;z-index:1;" class="upload" transfer>
                                            <div>
                                                <div :style="{
                                                    position: 'absolute', bottom: 0, right: 0, background: 'rgba(0,0,0,0.4)', color: '#fff',
                                                    padding: '3px 10px', fontSize: '10px', borderBottomLeftRadius: '5px'
                                                }">
                                                    {{ item.time }}
                                                </div>
                                                <div :style="{
                                                    position: 'absolute', top: 0, right: 0, background: ['', '#2d98f1', '#00d647'][item.status], color: '#fff',
                                                    padding: '3px 10px', fontSize: '10px', borderBottomLeftRadius: '5px'
                                                }">
                                                    {{ item.statusName }}
                                                </div>
                                                <img v-if="item.posterUrl" :src="item.posterUrl"
                                                    style="width: 100%;height:100%;" />
                                                <div style="padding: 5px;background: rgba(0,0,0,0.7) ;border-radius: 5px;position:absolute;
                                                            left:50%;top:50%;transform:translate(-50%,-50%)
                                                        " @click="handleShowPreview(item)">
                                                    <div
                                                        style="border-radius: 90px;border: 2px solid #fff;padding: 2px;">
                                                        <Icon type="ios-play-outline"
                                                            style="font-weight: bold;margin-left: 1px;" :size="20"
                                                            color="#fff" />
                                                    </div>
                                                </div>
                                            </div>
                                            <template #list>
                                                <DropdownMenu>
                                                    <DropdownItem name="baidu"
                                                        :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                                        百度网盘上传
                                                    </DropdownItem>
                                                    <DropdownItem name="local"
                                                        :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                                        本地上传
                                                    </DropdownItem>
                                                    <DropdownItem name="delete" :disabled="res.taskStatus == 1">删除
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </template>
                                        </Dropdown>

                                    </div>
                                    <div v-else-if="item.status === 4"
                                        style="position:absolute;inset:0;z-index: 1;background:#e5e8ec">
                                        <Spin fix class="loaders">
                                            <div class="loader">
                                                <svg class="circular" viewBox="25 25 50 50">
                                                    <circle class="path" cx="50" cy="50" r="20" fill="none"
                                                        stroke-width="5" stroke-miterlimit="10"></circle>
                                                </svg>

                                            </div>
                                            <div style="font-size: 14px;margin-left: 5px;color:#999">上传中...</div>
                                        </Spin>
                                    </div>
                                    <div v-else
                                        style="width: 100%;height: 100%;display:flex;align-items: center;justify-content: center;">
                                        <Dropdown @on-click="handleChooseUpload($event, 'single', item)"
                                            style="position: absolute;inset:0;z-index:1;" class="upload" transfer>
                                            <div
                                                style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)">
                                                <div style="color: #fc474c;text-align: center;white-space: nowrap;">
                                                    <Icon type="md-close-circle" :size="18" />
                                                    上传失败
                                                </div>
                                                <div style="word-break: break-all;margin-top: 5px;">原因说明：{{
                                                    item.failReason
                                                    }}</div>
                                            </div>
                                            <template #list>
                                                <DropdownMenu>
                                                    <DropdownItem name="baidu"
                                                        style="display: flex;align-items: center;"
                                                        :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                                        百度网盘上传
                                                    </DropdownItem>
                                                    <DropdownItem name="local"
                                                        :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                                        本地上传
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </template>
                                        </Dropdown>

                                    </div>
                                </div>
                            </div>
                            <Dropdown v-else @on-click="handleChooseUpload($event, 'single', item)"
                                style="position: absolute;inset:0;z-index:1;" class="upload" transfer>
                                <div
                                    style="position: absolute;inset:0;z-index:1;display:flex;align-items: center;justify-content: center;">
                                    <Icon type="ios-add" :size="50"></Icon>
                                </div>
                                <template #list>
                                    <DropdownMenu>
                                        <DropdownItem name="baidu"
                                            :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                            百度网盘上传</DropdownItem>
                                        <DropdownItem name="local"
                                            :disabled="res.taskStatus == 1 || !!(episodeLi.filter(i => i.status < 1&&i.name).length)">
                                            本地上传</DropdownItem>
                                    </DropdownMenu>
                                </template>
                            </Dropdown>

                        </div>
                        <div style="text-align: center;margin-top: 10px;font-size:15px;">第{{
                            (page.current - 1) * page.size + index + 1 }}集
                        </div>
                    </div>
                </div>

                <Pages :page="{
                    ...page,
                    total: form.playTotal
                }" :pArr="[18]" :showSizer="false" :func="handleChangePage" />
            </div>
            <explorer :appId="account.appId" ref="explorerRef" :chooseSeries="handleUpload"
                @get-choosed="handleUploadSingle" />
            <previewEpisode ref="previewRef" :data="resData" @getList="handlePutEpisodes"></previewEpisode>
            <template #footer>
                <!-- <Button v-if="res.taskStatus == 1" @click="handleCancelTask()">取消</Button> -->
                <Button @click="handleSubmitUpload" type="primary" :loading="uploadLoading"
                    v-if="res.taskStatus <= 1" :disabled="res.taskStatus == 1">上传</Button>
                <Poptip content="保存后，已发布的剧可在APP查看" trigger="hover">
                    <Button @click="handleSubmit" type="success" v-if="res.taskStatus > 1 && batchId" :loading="submitLoading1"
                        style="margin-left: 10px">保存</Button>
                </Poptip>
            </template>
            <input type="file" :multiple="multiple" ref="fileRef" style="display:none" @change="getFile"
                accept=".mp4" />
            <Modal footer-hide title="在线预览" v-model="previewVisible" class="modal" :width="420">
                <Videoplay v-if="previewVisible" :url="url" style="height: 600px;width: 337.5px" :poster-url="posterUrl" />
            </Modal>
            <Modal title="提示" v-model="tipVisible" class="modal">
                关闭此页面后，将清空本次的上传记录。您可以选择“转入后台上传”，上传任务将继续执行，返回页面后可查看上传进度。是否仍要关闭？
                <template #footer>
                    <Button @click="tipVisible = false">取消</Button>
                    <Button @click="$emit('update:visible', false); tipVisible = false" type="primary">转入后台</Button>
                    <Button
                        @click="handleCancelTask(); tipVisible = false"
                        type="error">确定关闭</Button>
                </template>
            </Modal>
        </Modal>
    </div>
</template>

<script>
import Pages from '@/components/pages'
import explorer from './explorer.vue';
import previewEpisode from './preview-episode.vue';
import { getEpisodesList, confirmVideoList, videoUpload, cancelTask, uploadSaveCheck, uploadSave, uploadSingleFile, delSeries } from '@/api/series'
import { getBaiduAccounts, checkChunk, uploadSeriesChunk as uploadSeries, mergeChunk } from '../../api/play';
import Videoplay from '../../components/VideoPlayer/index.vue';
import CryptoJS from 'crypto-js';
import SparkMD5 from 'spark-md5'
import Axios from 'axios';
import { cloneDeep } from 'lodash';
export default {
    components: {
        Pages,
        explorer,
        previewEpisode,
        Videoplay
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            default: () => ({})
        }
    },
    model: {
        prop: 'visible',
        event: 'update:visible'
    },
    data() {
        return {
            tipVisible: false,
            page: {
                current: 1,
                size: 18,
                total: 0,
            },
            previewVisible: false,
            url: '',
            posterUrl: '',
            fileList: [],
            submitLoading1: false,
            multiple: true,
            series: {},
            path: '',
            uploadType: 1, //0：本地,1：百度
            res: {},
            uploadLoading: false,
            resData: {},
            account: {},
            episodeLi: [],
            batchId: '',
            controller: {},
            controller1: {},
            abortFlag: false,
        }
    },
    watch: {
        visible() {
            if (this.visible) {
                this.handleReset()
                this.handleGetEpisodesList()
                this.handleGetBaiduAppId()
            }
        }
    },
    methods: {
        handleClickClose($event) {
            if ($event) return
            if (this.uploadType == 1 && this.res.taskStatus == 1) {
                this.tipVisible = true
            }
            else if (this.uploadType == 1 && this.res.taskStatus != 1 && this.episodeLi.find(i => i.name && i.status !== 2)) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '关闭此页面后，将清空本次的上传记录。是否仍要关闭？',
                    onOk: () => {
                        this.handleCancelTask()
                        this.$emit('update:visible', $event)
                    },
                    onCancel: () => { },
                    okText: '确认关闭'
                })
            }
            else if (this.uploadType == 0 && this.episodeLi.find(i => i.name && i.status !== 2)) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '关闭此页面后，将清空本次的上传记录。是否仍要关闭？',
                    onOk: () => {
                        this.handleCancelTask()
                        this.$emit('update:visible', $event)
                    },
                    onCancel: () => { },
                    okText: '确认关闭'
                })
            }
            else this.$emit('update:visible', $event)
        },
        handleDel(row){
            this.$Modal.confirm({
                title: '提示',
                content: '确定要删除吗？',
                onOk: ()=>{
                    delSeries(row).then(r => {
                        this.$Message.success('删除成功')
                        this.handleGetEpisodesList()
                    })
                },
                onCancel:()=>{}
            })
        },
        getFile(e) {
            if (![...e.target.files].length) return
            this.fileList = [...e.target.files].map(i => ({
                file: i
            }))
            if (this.multiple)
                this.handleUpload([...e.target.files].map(file => file.name), '')
            else {
                if (!e.target.files[0]) return
                this.uploadLoading = true
                const formData = new FormData()
                formData.append('file', e.target.files[0])
                console.log(e.target.files[0]);

                this.res.taskStatus = 1
                this.res.taskTotal = 1
                this.$set(this.res,'videoUploadSeriesVOList',cloneDeep([...this.res.videoUploadSeriesVOList.map(i=>{
                    i.isCurrentTask = false
                    return i
                })]))
                console.log(this.res.videoUploadSeriesVOList);
                
                this.res.successTotal = 0
                this.controller1 = Axios.CancelToken.source()
                // this.episodeLi[this.series.seriesNum - 1].status = 4
                this.$set(this.episodeLi, this.series.seriesNum - 1, {
                    ...this.episodeLi[this.series.seriesNum - 1],
                    status: 4,
                    name: e.target.files[0].name,
                    isCurrentTask: true
                })
                uploadSingleFile({
                    batchId: this.batchId,
                    playId: this.form.id,
                    seriesNum: this.series.seriesNum,
                    // appId: this.uploadType == 1 ? this.account.appId : '',
                    // baiduFileId: this.uploadType == 1 ? this.episodeLi.find(i => i.baiduFileId).baiduFileId : '',
                }, formData, { cancelToken: this.controller1.token }).then(r => {
                    this.batchId = r.data
                }).finally(() => {
                    this.$refs.fileRef.value = ''
                    this.uploadLoading = false
                    this.handleGetEpisodesList()
                })
            }
            this.$refs.fileRef.value = ''

        },
        async handleSubmitImport(file, token, seriesNum) {
            this.submitLoading = true
            const uploadedChunksMap = new Set()
            const chunkSize = 50 * 1024 * 1024;
            const totalChunks = Math.ceil(file.size / chunkSize);
            const maxRetries = 3;
            const baseDelay = 1000;
            const identifier = file.name
            try {
                const { data: checkRes } = await checkChunk({
                    playFileName: identifier,
                    batchId: this.batchId,
                    totalChunks: totalChunks
                })
                // 获取或创建该文件的已上传分片记录
                let unUploadLi = []
                if (checkRes) {
                    checkRes.map(i => {
                        if (i.uploaded) {
                            uploadedChunksMap.add(i.chunkNumber);
                        } else {
                            unUploadLi.push(i.chunkNumber)
                        }
                    })
                }
                const func = async (chunkNumber) => {
                    if (uploadedChunksMap.has(chunkNumber)) {
                        return;
                    }

                    let currentChunkSuccess = false;
                    let retries = 0;

                    while (!currentChunkSuccess && retries < maxRetries) {
                        // if (this.abortFlag) break;
                        try {
                            const start = (chunkNumber) * chunkSize;
                            const end = Math.min(start + chunkSize, file.size);
                            const chunk = file.slice(start, end);
                            const chunkMd5 = await new Promise((r) => {
                                const fileReader = new FileReader()
                                fileReader.onload = (e) => {
                                    const spark = new SparkMD5.ArrayBuffer();
                                    spark.append(e.target.result);
                                    const md5 = spark.end();
                                    r(md5)
                                }
                                fileReader.readAsArrayBuffer(chunk)
                            })
                            const formData = new FormData();
                            formData.append('file', chunk);
                            formData.append('playFileName', identifier);
                            formData.append('batchId', this.batchId);
                            formData.append('chunkMd5', chunkMd5);
                            formData.append('chunkNumber', chunkNumber);

                            const res = await uploadSeries(formData, { cancelToken: token });

                            if (res.code !== 200) {
                                throw new Error(res.msg || '上传失败');
                            }

                            uploadedChunksMap.add(chunkNumber);
                            this.uploadProgress = (uploadedChunksMap.size / totalChunks) * 100

                            currentChunkSuccess = true;


                        } catch (error) {

                            // if (this.abortFlag) return
                            retries++;
                            // if (retries === maxRetries) {
                            //   throw new Error(`分片 ${chunkNumber} 上传失败，已重试 ${maxRetries} 次`);
                            // }
                            const delay = Math.min(baseDelay * Math.pow(2, retries - 1) + Math.random() * 1000, 10000);
                            // this.$Message.warning(`分片 ${chunkNumber} 上传失败，${retries}秒后重试...`);
                            await new Promise(resolve => setTimeout(resolve, delay));
                        }
                    }

                    if (!currentChunkSuccess) {
                        throw new Error(`分片 ${chunkNumber} 上传失败`);
                    }

                    return
                }
                // this.uploadProgress = (uploadedChunksMap.size / totalChunks) * 100
                for (let chunkNumber = 0; chunkNumber <= unUploadLi.length - 1; chunkNumber += 5) {
                    // if (this.abortFlag) return

                    const funcLi = [() => func(unUploadLi[chunkNumber]),
                    () => chunkNumber + 1 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 1]) : Promise.resolve(),
                    () => chunkNumber + 2 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 2]) : Promise.resolve(),
                    () => chunkNumber + 3 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 3]) : Promise.resolve(),
                    () => chunkNumber + 4 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 4]) : Promise.resolve(),
                    ]
                    await Promise.all(funcLi.map(i => i()))
                }
                // 所有分片上传完成
                if (uploadedChunksMap.size === totalChunks) {
                    // if (this.abortFlag) return
                    const r = await mergeChunk({
                        fileName: file.name,
                        playId: this.form.id,
                        // seriesPrice: this.importForm.seriesPrice,
                        batchId: this.batchId,
                        playFileName: identifier,
                        fileSize: file.size
                    }).catch(async () => {
                        uploadedChunksMap.clear()
                        // const { data: checkRes } = await checkChunk({
                        //     playFileName: identifier,
                        //     batchId: this.batchId,
                        //     totalChunks: totalChunks
                        // })
                        // unUploadLi = []
                        // // 获取或创建该文件的已上传分片记录
                        // if (checkRes) {
                        //     checkRes.map(i => {
                        //         if (i.uploaded) {
                        //             uploadedChunksMap.add(i.chunkNumber);
                        //         } else {
                        //             unUploadLi.push(i.chunkNumber)
                        //         }
                        //     })
                        // }
                        // this.uploadProgress = (uploadedChunksMap.size / totalChunks) * 100
                        // for (let chunkNumber = 0; chunkNumber <= unUploadLi.length - 1; chunkNumber += 5) {
                        //     const funcLi = [() => func(unUploadLi[chunkNumber]),
                        //     () => chunkNumber + 1 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 1]) : Promise.resolve(),
                        //     () => chunkNumber + 2 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 2]) : Promise.resolve(),
                        //     () => chunkNumber + 3 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 3]) : Promise.resolve(),
                        //     () => chunkNumber + 4 <= unUploadLi.length - 1 ? func(unUploadLi[chunkNumber + 4]) : Promise.resolve(),
                        //     ]
                        //     await Promise.all(funcLi.map(i => i()))
                        // }
                        // if (uploadedChunksMap.size === totalChunks) {
                        //     await mergeChunk({
                        //         fileName: file.name,
                        //         playId: this.form.id,
                        //         batchId: this.batchId,
                        //         // seriesPrice: this.importForm.seriesPrice,
                        //         playFileName: identifier,
                        //         fileSize: file.size
                        //     }).catch(e=>{
                        //         this.handleCancelTask([seriesNum])
                        //     })
                        // }
                    })
                    
                    // this.$Message.success('上传完成')
                }
                this.submitLoading = false
                return;
            } catch(e) {
                // this.$delete(this.uploadProgress, this.importForm.file);
                uploadedChunksMap.clear(); // 清理上传记录
                this.submitLoading = false
            } 

        },
        decrypt(str) {
            const de = CryptoJS.AES.decrypt(str, CryptoJS.enc.Base64.parse('M28IxuBkkXxklZYAylvojA=='), {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            })
            // console.log(str, '',de.toString(CryptoJS.enc.Utf8));

            return de.toString(CryptoJS.enc.Utf8)
        },
        handlePutEpisodes(e) {
            console.log(e);

            e.map(i => {
                this.$set(this.episodeLi, i.seriesNum - 1, { ...i })
            })
            if (this.uploadType == 0) {
                this.fileList = this.fileList.filter(i => {
                    if (e.find(j => j.name == i.file.name && j.status === 0)) return true
                })
            }
            if (e.filter(i => i.status == 0).length) {
                this.$set(this.res, 'taskStatus', 0)
                return
            }
            if (e.filter(i => i.status == 1).length)
                this.$set(this.res, 'taskStatus', 2)

        },
        handleReset() {
            this.uploadLoading = false
            this.batchId = ''
            this.path = '',
                this.uploadType = 1, //0：本地,1：百度
                this.res = {},
                this.resData = {},
                // this.account = {},
                this.episodeLi = []
            this.page = {
                current: 1,
                size: 18,
                total: 0,
            }
        },
        async handleSubmitUpload(_, data) {
            if (!data) data = {}
            this.uploadLoading = true
            videoUpload({
                appId: this.uploadType == 1 ? this.account.appId : '',
                baiduFileIds: this.uploadType == 1 ? this.episodeLi.filter(i => i.baiduFileId && i.status == 0).map(i => i.baiduFileId) : [],
                localFileNames: this.uploadType == 0 ? this.fileList.map(i => i.file.name) : [],
                path: this.uploadType == 1 ? this.path : '',
                playId: this.form.id,
                uploadType: this.uploadType,
                batchId: this.batchId,
                ...data
            }).then(r => {
                this.batchId = r.data
                setTimeout(() => {
                    this.handleGetEpisodesList()
                }, 2000)
                // this.controller = new AbortController()
                if(this.uploadType == 0){
                    this.controller = Axios.CancelToken.source()
                    this.fileList.map(async (i) => {
                        await this.handleSubmitImport(i.file, this.controller.token, i.seriesNum)
                    })
                    setTimeout(() => {
                        this.handleGetEpisodesList()
                    }, 2000);
                    this.fileList = []
                }
            }).finally(() => {
                this.uploadLoading = false
            })
        },
        handleCancelTask(seriesNumbers, flag) {
            // const controller = new AbortController()
            // controller.abort()
            if (this.controller.cancel) {
                this.controller.cancel()
                // this.abortFlag = true
            }
            if (this.controller1.cancel) {
                this.controller1.cancel()
                // this.abortFlag = true
            }
            if (!this.batchId) {
                if (!flag) this.$emit('update:visible', false)
                return
            }
            cancelTask({
                playId: this.form.id,
                batchId: this.batchId,
                seriesNumbers: seriesNumbers
            }).then(r => {
                if(seriesNumbers.length){
                    this.handleGetEpisodesList()
                }else{
                    this.batchId = ''
                }
                this.$Message.success('取消成功')
                if (!flag) this.$emit('update:visible', false)
            })
        },
        handleShowPreview(row) {
            this.url = row.videoUrl
            this.posterUrl = row.posterUrl
            this.previewVisible = true
        },
        handleSubmit() {
            this.submitLoading1 = true
            uploadSaveCheck({
                batchId: this.batchId,
                playId: this.form.id,
                seriesNumbers: this.episodeLi.filter(i => i.name).filter(i=>i.status==1).map(i => i.seriesNum)
            }).then(r => {
                uploadSave({
                    batchId: this.batchId,
                    playId: this.form.id,
                    seriesNumbers: this.episodeLi.filter(i => i.name).filter(i=>i.status==1).map(i => i.seriesNum)
                }).then(r => {
                    this.$Message.success('保存成功')
                    this.batchId = ''
                    this.handleReset()
                    this.handleGetEpisodesList()
                    
                })
            }).catch(e => {
                if (e.code == '20002')
                    this.$Modal.confirm({
                        title: '剧集上传不完整',
                        content: e.data,
                        onOk: () => {
                            uploadSave({
                                batchId: this.batchId,
                                playId: this.form.id,
                                seriesNumbers: this.episodeLi.filter(i => i.name).map(i => i.seriesNum)
                            }).then(r => {
                                this.$Message.success('保存成功')
                                this.batchId = ''
                                this.handleReset()
                                this.handleGetEpisodesList()
                            })
                        },
                        okText: '确认保存'
                    })
                    else if(e.code == '20001'){
                        this.$Modal.info({
                            title: "检测到剧集不连续",
                            content: e.message,
                            onOk: () => {
                                
                            },
                            okText: '我已知晓',
                        })
                    }
                    else if(e.code == '20003'){
                        this.$Modal.confirm({
                            title: '内容已被更新',
                            render: ()=>{
                                return <div>
                                        
                                        您要保存的剧集,<span style="background: #fff895;">已在30分钟之内已被其他人更新过。</span>
                                    <br />
                                            <span style="color:red">确认保存将会覆盖对方近期的修改，此操作不可恢复。</span>
                                        <br />
                                        <span style="color:red">请问是否继续保存？</span>
                                    </div>
                            },
                            onOk: () => {
                                uploadSaveCheck({
                                    batchId: this.batchId,
                                    playId: this.form.id,
                                    seriesNumbers: this.episodeLi.filter(i => i.name).filter(i=>i.status==1).map(i => i.seriesNum),
                                    skipExistCheck: true
                                }).then(r=>{
                                    uploadSave({
                                        batchId: this.batchId,
                                        playId: this.form.id,
                                        seriesNumbers: this.episodeLi.filter(i => i.name).map(i => i.seriesNum)
                                    }).then(r => {
                                        this.$Message.success('保存成功')
                                        this.batchId = ''
                                        this.handleReset()
                                        this.handleGetEpisodesList()
                                    })
                                }).catch((err)=>{
                                    setTimeout(()=>{
                                        this.$Modal.confirm({
                                            title: '剧集上传不完整',
                                            content: err.data,
                                            onOk: () => {
                                                uploadSave({
                                                    batchId: this.batchId,
                                                    playId: this.form.id,
                                                    seriesNumbers: this.episodeLi.filter(i => i.name).map(i => i.seriesNum)
                                                }).then(r => {
                                                    this.$Message.success('保存成功')
                                                    this.batchId = ''
                                                    this.handleReset()
                                                    this.handleGetEpisodesList()
                                                })
                                            },
                                            okText: '确认保存'
                                        })
                                    },1000)
                                })
                            },
                            okText: '确认保存'
                        })
                    }
                else this.$Message.error(e.message)
            }).finally(()=>{
                this.submitLoading1 = false
            })
        },
        handleChangePage(current) {
            if (current) this.page.current = current
            else this.page.current = 1
        },
        getColor(flag) {
            if (flag == 0) {
                return '#ed4014'
            } else if (flag == 1) {
                return '#19be6b'
            } else {
                return '#ff9900'
            }
        },
        handleGetEpisodesList(flag) {
            if (this.form.id) {
                getEpisodesList({
                    playId: this.form.id,
                    batchId: this.batchId
                }).then(r => {
                    this.uploadType = r.data.uploadType
                    this.res = r.data
                    this.batchId = r.data.batchId
                    if (r.data.taskStatus > 1) this.uploadLoading = false
                    this.episodeLi = Array.from({ length: this.form.playTotal }, (v, k) => {
                        const item = r.data.videoUploadSeriesVOList.find(i => i.seriesNum == k + 1)
                        if (item) {
                            return {...item}
                        } else return {
                            seriesNum: k + 1
                        }
                    })
                    if (this.res.taskStatus === 1) {
                        let timer = setTimeout(() => {
                            if (this.res.taskStatus !== 1) {
                                clearTimeout(timer)
                                timer = null
                                return
                            }
                            this.handleGetEpisodesList()
                        }, 5000)
                    }

                })
            }
        },
        handleUploadSingle(data) {
            this.res.taskTotal = 1
            this.$set(this.res,'videoUploadSeriesVOList',cloneDeep([...this.res.videoUploadSeriesVOList.map(i=>{
                    i.isCurrentTask = false
                    return i
                })]))
                this.res.successTotal = 0
            this.$set(this.episodeLi[this.series.seriesNum - 1], 'status', 4)
            this.$set(this.episodeLi[this.series.seriesNum - 1], 'name', '1')
            this.$set(this.episodeLi[this.series.seriesNum - 1], 'isCurrentTask', true)
            this.res.taskStatus = 1
            uploadSingleFile({
                batchId: this.batchId,
                playId: this.form.id,
                seriesNum: this.series.seriesNum,
                appId: this.account.appId,
                baiduFileId: data,
            }).then(r => {
                this.batchId = r.data
                this.$refs.explorerRef.visible = false
            }).finally(() => {
                this.uploadLoading = false
                setTimeout(() => {
                    this.handleGetEpisodesList()
                }, 2000)
            })
            return
        },
        async handleUpload(dataList, path) {
            // this.uploadType = 1

            if (this.uploadType == 1) {
                await confirmVideoList({
                    appId: this.account.appId,
                    baiduFileIds: [...dataList],
                    path: path.path,
                    playId: this.form.id,
                    uploadType: this.uploadType
                }).then(r => {
                    this.resData = r.data

                    this.path = path.path
                    this.$refs.explorerRef.visible = false
                    this.$refs.previewRef.title = '百度云上传'
                    this.$refs.previewRef.visible = true
                }).catch((e) => {
                    this.$Message.error(e.message)
                })
                return true
            } else {
                await confirmVideoList({
                    localFileNames: [...dataList],
                    playId: this.form.id,
                    uploadType: this.uploadType
                }).then(r => {
                    this.resData = r.data
                    this.fileList = this.fileList.filter(i=>r.data.placeholderList.findIndex(j => j.name == i.file.name)>-1).map(i => ({
                        file: i.file,
                        seriesNum: r.data.placeholderList.find(j => j.name == i.file.name).seriesNum
                    }))
                    this.$refs.previewRef.title = '本地上传'
                    this.$refs.previewRef.visible = true
                }).catch((e) => {
                    this.$Message.error(e.message)
                })
            }

        },
        handleGetBaiduAppId() {
            getBaiduAccounts().then(r => {
                if (r.data.length)
                    this.account = r.data[0]
                else this.account = {}
            })
        },
        handleChooseUpload(e, single, item) {
            if (single) this.series = item
            else this.multiple = true
            if (e == 'baidu') {
                this.uploadType = 1
                // if (item && item.baiduFileId) {

                //     this.handleSubmitUpload('', {
                //         baiduFileIds: [item.baiduFileId],
                //         path: '',
                //     })
                //     return
                // }
                if (single) {
                    this.multiple = false
                    this.$refs.explorerRef.single = true
                } else {
                    this.$refs.explorerRef.single = false
                }
                this.$refs.explorerRef.visible = true
            }
            if (e == 'delete') {
                if (this.batchId) {
                    this.handleCancelTask([item.seriesNum], true)
                    this.$set(this.episodeLi, item.seriesNum - 1, {
                        seriesNum: item.seriesNum
                    })
                }
                if(item.seriesId){
                    this.handleDel(item.seriesId)
                }
                
                
                // this.episodeLi[item.seriesNum-1] = {}
            }
            if (e == 'local') {
                if (single) this.multiple = false
                this.uploadType = 0
                this.$nextTick(() => {
                    this.$refs.fileRef.click()
                })
            }
        }
    },
    mounted() {
        console.log(this.visible);

        if (this.visible) {
            this.handleReset()
            this.handleGetEpisodesList()
            this.handleGetBaiduAppId()
        }
    }
}
</script>
<style lang="less" scoped>
.upload {
    /deep/.ivu-dropdown-rel {
        width: 100%;
        height: 100%;
        position: relative;
    }
}

.path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round
}

.loaders {
    width: 100%;
    background-color: inherit;
    justify-content: center;

    /deep/.ivu-spin-main {
        // width: 100%;
        text-align: center;
    }

    /deep/.ivu-spin-text {
        display: flex;
        align-items: center;
        justify-content: center;

        &>* {
            flex-shrink: 0;
        }
    }
}

.loader {
    width: 30px;
    height: 30px;
    position: relative;
    display: flex;
    margin: 0 auto
}

.circular {
    // animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    // position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0
    }

    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35
    }

    to {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124
    }
}

@keyframes color {

    0%,
    to {
        stroke: #d62d20
    }

    40% {
        stroke: #0057e7
    }

    66% {
        stroke: #008744
    }

    80%,
    90% {
        stroke: #ffa700
    }
}

.modal {
    /deep/.ivu-modal-wrap {
        z-index: 1001 !important;
    }

    /deep/.ivu-modal-mask {
        z-index: 1001 !important;

    }
}
</style>